/**
 * Formats a webinar occurrence into a localized, human-readable label for the
 * timeslot picker, e.g. `Wed, 10 Jun 2026 | 5:30 PM - 6:15 PM GMT/BST` (en) or
 * `mié, 10 jun 2026 | 17:30 - 18:15 CET` (es-ES).
 *
 * The locale drives weekday/month names and the 12h vs 24h clock automatically
 * via `Intl.DateTimeFormat`; the server-side timezone (`timeZone`) keeps the
 * displayed wall-clock time in the webinar's region regardless of the viewer's
 * device timezone. `tzDisplay` is the short zone label appended verbatim.
 */
export function formatWebinarSlotLabel(
  locale: string,
  startISO: string,
  endISO: string,
  timeZone: string,
  tzDisplay: string
): string {
  const start = new Date(startISO);
  const end = new Date(endISO);

  const dateStr = new Intl.DateTimeFormat(locale, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone,
  }).format(start);

  const timeFormatter = new Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: '2-digit',
    timeZone,
  });

  const startStr = timeFormatter.format(start);
  const endStr = timeFormatter.format(end);

  return `${dateStr} | ${startStr} - ${endStr} ${tzDisplay}`.trim();
}
